import { render, staticRenderFns } from "./EstablishmentsDashboard.vue?vue&type=template&id=ba9bccb8&scoped=true&"
import script from "./EstablishmentsDashboard.vue?vue&type=script&lang=ts&"
export * from "./EstablishmentsDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./EstablishmentsDashboard.vue?vue&type=style&index=0&id=ba9bccb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9bccb8",
  null
  
)

export default component.exports